module.exports = function getResource(label, vars = []) {
    let resources = {
        eyeColor: 'Couleur des yeux',
        blue: 'Bleu',
        brown: 'Brun',
        green: 'Vert',
        gray: 'Gris',
        hazel: 'Noisette',
        hairColor: 'Couleur des cheveux',
        blonde: 'Blond',
        brunette: 'Brunette',
        auburn: 'Auburn',
        black: 'Noir',
        red: 'Rouge',
        skinTone: 'Ton de peau',
        porcelain: 'Porcelaine',
        fair: 'Pâle',
        light: 'Légère',
        medium: 'Moyenne',
        tan: 'Bronzé',
        olive: 'Olive',
        deep: 'Très foncé',
        dark: 'Foncé',
        ebony: 'Ébène',
        skinType: 'Type de peau',
        normal: 'Normale',
        combination: 'Mixte',
        dry: 'Sèche',
        oily: 'Grasse',
        skinConcerns: 'Préoccupations cutanées',
        acne: 'Peau à tendance acnéique',
        aging: 'Vieillissement',
        blackheads: 'Points noirs',
        calluses: 'Durillon',
        cellulite: 'Cellulite',
        cuticles: 'Cuticules',
        darkCircles: 'Cernes',
        dullness: 'Teint terne',
        redness: 'Rougeurs',
        sensitivity: 'Sensibilité',
        stretchMarks: 'Vergetures',
        sunDamage: 'Endommagée par le soleil',
        unevenSkinTones: 'Teint inégal',
        hairType: 'Type de cheveux',
        chemicallyTreated: 'Traités avec des produits chimiques',
        coarse: 'Épais',
        curly: 'Frisés',
        fine: 'Fins',
        straight: 'Raides',
        wavy: 'Bouclés',
        hairConcerns: 'Problèmes de cheveux',
        antiAging: 'anti-âge',
        colorProtection: 'Protection de la couleur',
        curlEnhancing: 'Sculpture des boucles',
        damaged: 'Abîmés',
        dandruff: 'Pellicules',
        frizz: 'Frisottis',
        heatProtection: 'Protecteurs contre la chaleur',
        hold: 'Tenue',
        oiliness: 'Tendance grasse',
        shine: 'Lustrer',
        straighteningSmoothing: 'Raidir/Lisser',
        thinning: 'Cheveux dégarnis',
        volumizing: 'Volumisant',
        ageRange: 'Tranche d’âge',
        content: 'Contenu',
        photos: 'Photos',
        video: 'Vidéo',
        verifiedPurchases: 'Achats vérifiés',
        mostHelpful: 'Le plus utile',
        newest: 'Nouveauté',
        oldest: 'Le plus ancien',
        highestRating: 'Évaluation la plus élevée',
        lowestRating: 'Évaluation la plus basse',
        rating: 'Cote'
    };

    return resources[label];
};
